import cx from 'classnames';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import Cookies from 'js-cookie';
import React, { Component, useState } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import validator from 'validator/es';

import { media } from '../../../styles/media';
import { isAnyFacilityPage } from '../../../utils/kitchen-growth-helpers';
import { Button } from '../../ui';

const Section = styled.section`
  .iti__selected-flag {
    padding: 0;
  }
  .country--holder {
    display: flex;
    align-items: flex-end;
    padding: 0 0 30px;
    @media ${media.mdUp} {
      padding: 0 0 40px;
    }
  }
  .country-select {
    display: none;
  }
  .iti__selected-dial-code,
  input::placeholder {
    color: var(--grey-4);
  }
  input:focus::placeholder {
    color: transparent;
  }
  .secondary {
    .iti__arrow {
      border-inline-start: 3px solid transparent;
      border-inline-end: 3px solid transparent;
      border-top: 4px solid var(--white);
      &.iti__arrow--up {
        border-top: none;
        border-bottom: 4px solid var(--white);
      }
    }
    .country-select {
      background: var(--accent-1);
    }
    .iti__selected-dial-code,
    input::placeholder {
      color: var(--grey-3);
    }
    input:focus::placeholder {
      color: transparent;
    }
  }
  .iti--allow-dropdown,
  .iti--separate-dial-code {
    width: 85px;
  }
  .iti__selected-dial-code {
    font-weight: 500;
  }
  .iti__country-list {
    margin-top: 15px;
  }
  .form--variant--white {
    .react-select__placeholder {
      color: var(--grey-3) !important;
    }
    .react-select__single-value {
      color: var(--white) !important;
    }
    .form--element--placeholder {
      color: var(--grey-3) !important;
    }
  }
`;

const AcceptTerms = ({ color, fields, acceptStateHandler, submitted }) => {
  const [isChecked, setIsChecked] = useState(false);
  const checkHandler = () => {
    setIsChecked(!isChecked);
    acceptStateHandler({ acceptance: !isChecked });
  };
  return (
    <div
      className={cx(
        'form--element--terms mt-30 relative',
        submitted && !isChecked ? 'error' : ''
      )}>
      <input
        className="!absolute left-0 top-0"
        checked={isChecked}
        onChange={checkHandler}
        type="checkbox"
        id="accept-terms"
      />
      <label
        htmlFor="accept-terms"
        className={cx(
          'form--element--label-small pl-5',
          // parentId === '#block-hero-form' ? 'color--white' : 'color--grey-5'
          color === 'white' ? 'color--white' : 'color--grey-4'
        )}>
        {fields?.contact_i_have_read_and_understood}{' '}
        <a className="underline" href="/privacy-policy/" target="_blank">
          {fields?.contact_privacy_policy}
        </a>{' '}
        {fields?.contact_and}{' '}
        <a className="underline" href="/cookies-policy/" target="_blank">
          {fields?.contact_cookie_policy}
        </a>
      </label>
    </div>
  );
};

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      utm_campaign: '',
      utm_channel: '',
      utm_source: '',
      utm_ad: '',
      utm_term: '',
      url: '',
      submitted: false,
      acceptance: false,
    };
  }

  acceptStateHandler = (state) => {
    this.setState(state);
  };

  componentDidMount() {
    window.intlTelInput = intlTelInput;

    // UTM for Source Detail | UTM CACHING AND COOKIE MANAGEMENT
    const detailFields = document.getElementById('00Nf400000UVpl3');
    const findChars = (str, busqueda) => {
      const indices = [];
      for (let i = 0; i < str.length; i++) {
        if (str[i] === busqueda) indices.push(i);
      }
      return indices;
    };

    let detail = window.location.href;
    const indexSlashes = findChars(detail, '/');
    detail = detail.substr(
      indexSlashes[indexSlashes.length - 1] + 1,
      detail.length
    );
    if (detail.indexOf('#') > -1) {
      const indexHashtags = findChars(detail, '#');
      detail = detail.substr(0, indexHashtags[indexHashtags.length - 1]);
    }

    try {
      detailFields.value = detail;
      if (detailFields.value.length > 0) {
        Cookies.set('fullUTM', detail, {
          expires: 90,
        });
      }
      const source = Cookies.get('fullUTM');
      if (source && source.toString().length > 0) {
        detailFields.value = source;
      }
    } catch (err) {
      console.warn(err);
    }

    this.state.utm_source = this.getUrlParam('utm_source');
    this.state.utm_channel = this.getUrlParam('utm_channel');
    this.state.utm_campaign = isAnyFacilityPage()
      ? 'Facility Finder'
      : this.getUrlParam('utm_campaign');
    this.state.utm_ad = this.getUrlParam('utm_ad');
    this.state.utm_term = this.getUrlParam('utm_term');

    const url = typeof window !== 'undefined' ? window.location.search : '';
    this.state.url = url;

    const urlSearch =
      typeof window !== 'undefined' ? window.location.pathname.split('/') : '';

    // Flag + Country picker scripts
    const input = document.querySelector(
      `.${this.props.prefixId}-country-select`
    );

    if (urlSearch[1] === 'panama') {
      window.intlTelInput(input, {
        initialCountry: 'pa',
        separateDialCode: true,
        onlyCountries: ['pa'],
        allowDropdown: false,
      });
    } else if (this.props.fields.site_name === 'CocinasOcultas') {
      window.intlTelInput(input, {
        initialCountry: this.props.fields.country_code,
        separateDialCode: true,
        onlyCountries: ['co', 'pe'],
      });
    } else {
      window.intlTelInput(input, {
        initialCountry: this.props.fields.country_code,
        separateDialCode: true,
        onlyCountries: [this.props.fields.country_code],
      });
    }
  }

  getAreaCodeFromLocation = (location) => {
    const input = document.querySelector(
      `.${this.props.prefixId}-country-select`
    );
    const iti = window.intlTelInputGlobals.getInstance(input);
    switch (location) {
      case 'Bogota':
        iti.setCountry('co');
        break;
      case 'Barranquilla':
        iti.setCountry('co');
        break;
      case 'Cali':
        iti.setCountry('co');
        break;
      case 'Medellin':
        iti.setCountry('co');
        break;
      case 'Lima':
        iti.setCountry('pe');
        break;
      case 'Panama City':
        iti.setCountry('pa');
        break;
      case 'Quito':
        iti.setCountry('ec');
        break;
      case 'San Jose - CR':
        iti.setCountry('cr');
        break;
      case 'Brasilia':
        iti.setCountry('br');
        break;
      case 'Rio de Janeiro':
        iti.setCountry('br');
        break;
      case 'Sao Paulo':
        iti.setCountry('br');
        break;
      case 'Belo Horizonte':
        iti.setCountry('br');
        break;
      case 'Mexico City':
        iti.setCountry('mx');
        break;
      case 'Guadalajara':
        iti.setCountry('mx');
        break;
      case 'Monterrey':
        iti.setCountry('mx');
        break;
      case 'Santiago':
        iti.setCountry('cl');
        break;
    }
  };

  getUrlParam = (param) => {
    if (Cookies.get('fullUTM') !== undefined) {
      return Cookies.get('fullUTM').replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        (m, key, value) => (key === param ? value : '')
      );
    }
    return '';
  };

  inputFocus = (e) => {
    const { id } = e.currentTarget.dataset;
    const parent = document.querySelector(
      `${this.props.parentId} .form--element[data-id=${id}]`
    );
    parent.classList.add('focus');
  };

  inputType = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
    const current = e.currentTarget;
    const text = current.innerHTML;
    const { id } = current.dataset;
    const parent = document.querySelector(
      `${this.props.parentId} .form--element[data-id=${id}]`
    );
    const border = document.querySelector(
      `${this.props.parentId} .form--element--border[data-id=${id}]`
    );
    if (text) {
      parent.classList.remove('done');
      parent.classList.add('active');
      const width = current.clientWidth;
      border.style.width = `${width + 24}px`;
    } else {
      parent.classList.remove('active');
      border.style.width = '0px';
    }
  };

  required = ($type, $name) => {
    const holder = document.querySelector(
      `${this.props.parentId} .form--element[data-id="${$type}"]`
    );
    const label = document.querySelector(
      `${this.props.parentId} .form--element[data-id="${$type}"] .form--element--label`
    );
    holder.classList.add('focus');
    holder.classList.add('error');
    if ($type === 'phone') {
      label.innerHTML = 'Please provide a valid phone number';
    } else {
      label.innerHTML = `${$name} Requerido`;
    }
  };

  resetLabel = ($type, $name) => {
    const holder = document.querySelector(
      `${this.props.parentId} .form--element[data-id="${$type}"]`
    );
    const label = document.querySelector(
      `${this.props.parentId} .form--element[data-id="${$type}"] .form--element--label`
    );
    holder.classList.remove('error');
    label.innerHTML = `${$name}`;
  };

  phoneValidation = () => {
    // VALIDAR TELEFONO

    const dialNum = document.querySelector(
      `.country--holder[data-id=${this.props.prefixId}-country] .iti__selected-dial-code`
    );
    /* const valueNum = document.querySelector(
      `.country--holder[data-id=${this.props.prefixId}-country] .iti__standard.iti__active`
    ); */

    const dialCode = dialNum.innerText;
    // const valuenumber = valueNum.dataset.countryCode;
    let num = this.props.phone;

    if (num.length <= 0 || num.length === undefined) {
      return '*Requerido';
    }

    // MEXICO
    // if (valuenumber === 'mx') {
    if (dialCode === '+52') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 10) {
        num = `${num.slice(0, 2)} ${num.slice(2, 6)} ${num.slice(6, 10)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 10) {
        if (cantidadnum <= 0) {
          return '*Requerido';
        }
        return '*10 dígitos';
      }
      // ESPAÑA
      // } else if (valuenumber === 'es') {
    } else if (dialCode === '+34') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 9) {
        num = `${num.slice(0, 3)} ${num.slice(3, 5)} ${num.slice(
          5,
          7
        )} ${num.slice(7, 9)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 9) {
        if (cantidadnum <= 0) {
          return '*Requerido';
        }
        return '*9 dígitos';
      }

      // VENEZUELA
      // } else if (valuenumber === 've') {
    } else if (dialCode === '+58') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 10) {
        num = `${num.slice(0, 3)}-${num.slice(3, 10)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 10) {
        if (cantidadnum <= 0) {
          return '*Requerido';
        }
        return '*10 dígitos';
      }
      // ARGENTINA
      // } else if (valuenumber === 'ar') {
    } else if (dialCode === '+54') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 10) {
        num = `9 ${num.slice(0, 2)} ${num.slice(2, 6)}-${num.slice(6, 10)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 10) {
        if (cantidadnum <= 0) {
          return '*Requerido';
        }
        return '*10 dígitos';
      }

      // PERU
      // } else if (valuenumber === 'pe') {
    } else if (dialCode === '+51') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 9) {
        num = `${num.slice(0, 3)} ${num.slice(3, 6)} ${num.slice(6, 9)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 9) {
        if (cantidadnum <= 0) {
          return '*Requerido';
        }
        return '*9 dígitos';
      }
      // PANAMA
      // } else if (valuenumber === 'pa') {
    } else if (dialCode === '+507') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 8) {
        num = `${num.slice(0, 4)}-${num.slice(4, 8)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 8) {
        if (cantidadnum <= 0) {
          return '*Requerido';
        }
        return '*8 dígitos';
      }
      // ECUADOR
      // } else if (valuenumber === 'ec') {
    } else if (dialCode === '+593') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 9) {
        num = `${num.slice(0, 2)} ${num.slice(2, 5)} ${num.slice(5, 9)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 9) {
        if (cantidadnum <= 0) {
          return '*Requerido';
        }
        return '*9 dígitos';
      }
      // COSTA RICA
      // } else if (valuenumber === 'cr') {
    } else if (dialCode === '+506') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 8) {
        num = `${num.slice(0, 4)} ${num.slice(4, 8)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 8) {
        if (cantidadnum <= 0) {
          return '*Requerido';
        }
        return '*8 dígitos';
      }
      // COLOMBIA
      // } else if (valuenumber === 'co') {
    } else if (dialCode === '+57') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 10) {
        num = `${num.slice(0, 3)} ${num.slice(3, 10)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 10) {
        if (cantidadnum <= 0) {
          return '*Requerido';
        }
        return '*10 dígitos';
      }
      // CHILE
      // } else if (valuenumber === 'cl') {
    } else if (dialCode === '+56') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 9) {
        num = `${num.slice(0, 1)} ${num.slice(1, 5)} ${num.slice(5, 9)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 9) {
        if (cantidadnum <= 0) {
          return ' *Requerido';
        }
        return ' *9 dígitos';
      }
      // BRAZIL
      // } else if (valuenumber === 'br') {
    } else if (dialCode === '+55') {
      num = num.toString();
      num = num.replace(/\D+/g, '');
      const cantidadnum = num.length;
      if (cantidadnum === 11) {
        num = `${num.slice(0, 2)} ${num.slice(2, 7)}-${num.slice(7, 11)}`;
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum === 10) {
        document.getElementById('phone').value = `${dialCode} ${num}`;
        return 'success';
      }
      if (cantidadnum !== 11) {
        if (cantidadnum <= 0) {
          return ' *Requerido';
        }
        return ' *10 u 11 dígitos';
      }
    }
  };

  form1Click = (e) => {
    if (e) e.preventDefault();

    const firstName = this.props.fields.first_name;
    const lastName = this.props.fields.last_name;
    const { phone } = this.props.fields;
    const { restaurant } = this.props.fields;
    const { email } = this.props.fields;
    const location = this.props.fields.region;
    const restaurant_number = this.props.fields.restaurant_number;
    const type_of_restaurant = this.props.fields.type_of_restaurant;
    const role = this.props.fields.role;
    const Landing_Page_URL_c__c = window.location.href;

    this.setState({ submitted: true });

    if (!validator.isLength(this.props.firstName, { min: 1, max: undefined })) {
      this.required(`${this.props.prefixId}-first-name`, firstName);
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-first-name`, firstName);

    if (!validator.isLength(this.props.lastName, { min: 1, max: undefined })) {
      this.required(`${this.props.prefixId}-last-name`, lastName);
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-last-name`, lastName);

    const phoneValidationResult = this.phoneValidation();
    if (phoneValidationResult !== 'success') {
      const holder = document.querySelector(
        `${this.props.parentId} .form--element[data-id="${this.props.prefixId}-phone"]`
      );
      const label = document.querySelector(
        `${this.props.parentId} .form--element[data-id="${this.props.prefixId}-phone"] .form--element--label`
      );
      holder.classList.add('focus');
      holder.classList.add('error');

      label.innerHTML = phoneValidationResult;

      return false;
    }
    this.resetLabel(`${this.props.prefixId}-phone`, phone);

    if (!validator.isEmail(this.props.email)) {
      this.required(`${this.props.prefixId}-email`, email);
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-email`, email);

    if (!validator.isLength(this.props.company, { min: 1, max: undefined })) {
      this.required(`${this.props.prefixId}-company`, restaurant);
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-company`, restaurant);

    if (
      !validator.isLength(this.props.restaurantNumbers, {
        min: 1,
        max: undefined,
      })
    ) {
      this.required(`${this.props.prefixId}-numbers`, restaurant_number);
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-numbers`, restaurant_number);

    if (
      !validator.isLength(this.props.locations, {
        min: 1,
        max: undefined,
      })
    ) {
      this.required(`${this.props.prefixId}-locations`, location);
      return false;
    }

    this.resetLabel(`${this.props.prefixId}-locations`, location);

    if (
      !validator.isLength(this.props.typeOfRestaurants, {
        min: 1,
        max: undefined,
      })
    ) {
      this.required(`${this.props.prefixId}-type`, type_of_restaurant);
      return false;
    }

    this.resetLabel(`${this.props.prefixId}-type`, type_of_restaurant);

    if (
      !validator.isLength(this.props.restaurantRoles, {
        min: 1,
        max: undefined,
      })
    ) {
      this.required(`${this.props.prefixId}-role`, role);
      return false;
    }

    this.resetLabel(`${this.props.prefixId}-role`, role);

    if (!this.state.acceptance) {
      return false;
    }

    const postUrl =
      'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8';

    const dialNum = document.querySelector(
      `.country--holder[data-id=${this.props.prefixId}-country] .iti__selected-dial-code`
    );

    const urlSearch =
      typeof window !== 'undefined' ? window.location.pathname.split('/') : '';

    const body = {
      oid: '00Df4000003jvM8',
      '00Nf400000UWoqU': this.props.fields.country, // Kitchen Country
      '00Nf400000Nk64e':
        urlSearch[1] === 'panama' ? 'Panama City' : this.props.locations.trim(), // Kitchen City
      '00N5G00000V8EjA': this.state.utm_source, // URM source
      '00N5G00000VKthJ': this.state.utm_channel, // URM Channel
      '00N5G00000V8Ej7': this.state.utm_campaign, // URM Medium
      '00N5G00000VKthI': this.state.utm_term, // URM Term
      '00Nf400000UVpl3': this.state.utm_ad, // Lead Source Detail = URL variable string
      lead_source: 'Inbound: Website', // Lead Source -- Inbound: Website
      first_name: this.props.firstName.trim(),
      last_name: this.props.lastName.trim(),
      phone: `${
        urlSearch[1] === 'panama' ? '507' : dialNum.innerText.trim()
      }${this.props.phone.trim()}`,
      company: this.props.company.trim(),
      email: this.props.email.trim(),
      Number_of_Locations__c: this.props.restaurantNumbers.trim(),
      Kitchen_Type__c: this.props.typeOfRestaurants.trim(),
      RoleInRestaurant__c: this.props.restaurantRoles.trim(),
      Landing_Page_URL_c__c: Landing_Page_URL_c__c,
      // debug: 1,
      // debugEmail: 'jesse.goodnoe@cloudkitchens.com',
    };

    const encode = (data) =>
      Object.keys(data)
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join('&');

    fetch(postUrl, {
      method: 'post',
      mode: 'no-cors',
      body: encode(body),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
      .then(() => {
        const form1 = document.querySelector(`${this.props.parentId} .form-1`);
        const form2 = document.querySelector(`${this.props.parentId} .form-2`);
        form1.classList.remove('is-active');
        form2.classList.add('is-active');

        if (this.props.parentId === '#modal--contact') {
          const modal = document.getElementById('modal--contact');
          modal.scrollTo(0, 0);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'formSubmit',
          form_step: 'success',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  radioLabel = () => {
    const label = document.querySelector('.label--radio');
    label.classList.remove('color--grey-4');
    label.classList.add('color--grey-6');
    const valuesArray = document.querySelectorAll(
      `${this.props.parentId} input[name="orders[]"]:checked`
    );
    let valueString = '';
    for (const checkbox of valuesArray) {
      valueString += `${checkbox.value};`;
    }
    this.props.stateHandler({ orders: valueString.slice(0, -1) });
    // this.props.orders = valueString.slice(0, -1);
    // this.setState({ orders: valueString.slice(0, -1) });
  };

  inputReset = (e) => {
    const current = e.currentTarget;
    const text = current.innerHTML;
    const { id } = current.dataset;
    const parent = document.querySelector(
      `${this.props.parentId}  .form--element[data-id=${id}]`
    );
    const border = document.querySelector(
      `${this.props.parentId}  .form--element--border[data-id=${id}]`
    );
    if (!text) {
      parent.classList.remove('done');
      parent.classList.remove('focus');
      parent.classList.remove('active');
      border.style.width = '0px';
    } else {
      parent.classList.add('done');
    }
  };

  handlePreferredLocationsChange = (preferredLocationsValue) => {
    const element = document.querySelector(
      `${this.props.parentId}  .form--element--preferred-locations`
    );
    if (preferredLocationsValue.value !== '') {
      element.classList.add('is-active');
    } else {
      element.classList.remove('is-active');
    }
    this.getAreaCodeFromLocation(preferredLocationsValue.value);
    this.props.stateHandler({ locations: preferredLocationsValue.value });
  };

  handleRestaurantNumbersChange = (e) => {
    if (e.target.value > 1000) {
      e.target.value = 1000;
    } else if (e.target.value < 0) {
      e.target.value = 0;
    }
    e.target.value = Math.round(e.target.value);
    this.props.stateHandler({
      restaurantNumbers: e.target.value.trim(),
    });
  };

  handleTypesOfRestaurants = (typeRestaurantValue) => {
    const element = document.querySelector(
      `${this.props.parentId}  .form--element--type-of-restaurant`
    );
    if (typeRestaurantValue.value !== '') {
      element.classList.add('is-active');
    } else {
      element.classList.remove('is-active');
    }
    this.props.stateHandler({
      types_of_restaurants: typeRestaurantValue.value,
    });
    this.props.stateHandler({ typeOfRestaurants: typeRestaurantValue.value });
  };

  handleRoles = (rolesValue) => {
    const element = document.querySelector(
      `${this.props.parentId}  .form--element--role`
    );
    if (rolesValue.value !== '') {
      element.classList.add('is-active');
    } else {
      element.classList.remove('is-active');
    }
    this.props.stateHandler({
      roles: rolesValue.value,
    });
    this.props.stateHandler({ restaurantRoles: rolesValue.value });
  };

  render() {
    const formElementClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element secondary'
        : 'form--element';
    const labelClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--label color--white'
        : 'form--element--label';
    const textClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--text color--white'
        : 'form--element--text';
    const placeholderClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--placeholder secondary'
        : 'form--element--placeholder';
    const borderClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--border color--white'
        : 'form--element--border';

    const { regions, types_of_restaurants, roles } = this.props.fields;

    const urlSearch =
      typeof window !== 'undefined' ? window.location.pathname.split('/') : '';

    return (
      <Section>
        <div
          className={cx({
            'form--variant--white': this.props.color === 'white',
          })}>
          <input id="00Nf400000UVpl3" type="hidden" name="00Nf400000UVpl3" />
          <input id="phone" type="hidden" />
          <div className={`form-1 is-active`}>
            {this.props.form_content ? (
              <p className="mb-30 color--white small">
                {this.props.form_content}
              </p>
            ) : (
              ''
            )}
            <div className="md:grid md:grid-cols-2 md:gap-6">
              <div
                className={formElementClassName}
                data-id={`${this.props.prefixId}-first-name`}>
                <label className={labelClassName}>
                  {this.props.fields.first_name}
                </label>
                <div
                  className={textClassName}
                  contentEditable="true"
                  spellCheck="false"
                  data-id={`${this.props.prefixId}-first-name`}
                  onFocus={this.inputFocus}
                  onKeyDown={this.inputType}
                  onBlur={this.inputReset}
                  onKeyUp={(e) => {
                    this.props.stateHandler({
                      firstName: e.target.innerText.trim(),
                    });
                  }}
                />
                <div className={placeholderClassName}>
                  {this.props.fields.first_name}
                </div>
                <div
                  className={borderClassName}
                  data-id={`${this.props.prefixId}-first-name`}
                />
              </div>
              <div
                className={formElementClassName}
                data-id={`${this.props.prefixId}-last-name`}>
                <label className={labelClassName}>
                  {this.props.fields.last_name}
                </label>
                <div
                  className={textClassName}
                  contentEditable="true"
                  spellCheck="false"
                  data-id={`${this.props.prefixId}-last-name`}
                  onFocus={this.inputFocus}
                  onKeyDown={this.inputType}
                  onBlur={this.inputReset}
                  onKeyUp={(e) => {
                    this.props.stateHandler({
                      lastName: e.target.innerText.trim(),
                    });
                  }}
                />
                <div className={placeholderClassName}>
                  {this.props.fields.last_name}
                </div>
                <div
                  className={borderClassName}
                  data-id={`${this.props.prefixId}-last-name`}
                />
              </div>
            </div>
            <div className="flex">
              <div
                className={`country--${formElementClassName} country--holder`}
                data-id={`${this.props.prefixId}-country`}>
                <input
                  className={`${this.props.prefixId}-country-select country-select`}
                />
              </div>
              <div
                className={formElementClassName}
                data-id={`${this.props.prefixId}-phone`}>
                <label className={labelClassName}>
                  {this.props.fields.phone}
                </label>
                <div
                  className={textClassName}
                  contentEditable="true"
                  spellCheck="false"
                  data-id={`${this.props.prefixId}-phone`}
                  onFocus={this.inputFocus}
                  onKeyDown={this.inputType}
                  onBlur={this.inputReset}
                  onKeyUp={(e) => {
                    this.props.stateHandler({
                      phone: e.target.innerText.trim(),
                    });
                  }}
                />
                <div className={placeholderClassName}>
                  {this.props.fields.phone}
                </div>
                <div
                  className={borderClassName}
                  data-id={`${this.props.prefixId}-phone`}
                />
              </div>
            </div>

            <div
              className={formElementClassName}
              data-id={`${this.props.prefixId}-email`}>
              <label className={labelClassName}>
                {this.props.fields.email}
              </label>
              <div
                className={textClassName}
                contentEditable="true"
                spellCheck="false"
                data-id={`${this.props.prefixId}-email`}
                onFocus={this.inputFocus}
                onKeyDown={this.inputType}
                onBlur={this.inputReset}
                onKeyUp={(e) => {
                  this.props.stateHandler({ email: e.target.innerText.trim() });
                }}
              />
              <div className={placeholderClassName}>
                {this.props.fields.email}
              </div>
              <div
                className={borderClassName}
                data-id={`${this.props.prefixId}-email`}
              />
            </div>

            <div className="md:grid md:grid-cols-2 md:gap-6">
              <div
                className={formElementClassName}
                data-id={`${this.props.prefixId}-company`}>
                <label className={labelClassName}>
                  {this.props.fields.restaurant}
                </label>
                <div
                  className={textClassName}
                  contentEditable="true"
                  spellCheck="false"
                  data-id={`${this.props.prefixId}-company`}
                  onFocus={this.inputFocus}
                  onKeyDown={this.inputType}
                  onBlur={this.inputReset}
                  onKeyUp={(e) => {
                    this.props.stateHandler({
                      company: e.target.innerText.trim(),
                    });
                  }}
                />
                <div className={placeholderClassName}>
                  {this.props.fields.restaurant}
                </div>
                <div
                  className={borderClassName}
                  data-id={`${this.props.prefixId}-company`}
                />
              </div>

              <div
                className={`${formElementClassName} form--element--number-locations`}
                data-id={`${this.props.prefixId}-numbers`}>
                <label className={labelClassName}>
                  {this.props.fields.restaurant_number}
                </label>
                <input
                  className={cx('!relative bg-[transparent]', textClassName)}
                  type="number"
                  min="0"
                  max="1000"
                  step="1"
                  placeholder={this.props.fields.restaurant_number}
                  spellCheck="false"
                  data-id={`${this.props.prefixId}-numbers`}
                  onFocus={this.inputFocus}
                  onKeyDown={this.inputType}
                  onChange={(e) => {
                    this.handleRestaurantNumbersChange(e);
                  }}
                />
                <div
                  className={borderClassName}
                  data-id={`${this.props.prefixId}-numbers`}
                />
              </div>
            </div>

            {urlSearch[1] !== 'panama' ? (
              <div
                className={`${formElementClassName} form--element--preferred-locations mb-0`}
                data-id={`${this.props.prefixId}-locations`}>
                <label className={labelClassName}>
                  {this.props.fields.region}
                </label>
                <Select
                  className="form--element--select"
                  classNamePrefix="react-select"
                  id={`${this.props.prefixId}-preferredLocation`}
                  name="locations"
                  placeholder={this.props.fields.region}
                  isSearchable={false}
                  isClearable={false}
                  cache={false}
                  onChange={this.handlePreferredLocationsChange}
                  options={regions}
                />
              </div>
            ) : (
              ''
            )}

            <div
              className={`${formElementClassName} form--element--type-of-restaurant mb-0`}
              data-id={`${this.props.prefixId}-type`}>
              <label className={labelClassName}>
                {this.props.fields.type_of_restaurant}
              </label>
              <Select
                className="form--element--select"
                classNamePrefix="react-select"
                id={`${this.props.prefixId}-typeOfRestaurant`}
                name="type of restaurants"
                placeholder={this.props.fields.type_of_restaurant}
                isSearchable={false}
                isClearable={false}
                cache={false}
                onChange={this.handleTypesOfRestaurants}
                options={types_of_restaurants}
              />
            </div>

            <div
              className={`${formElementClassName} form--element--role mb-0`}
              data-id={`${this.props.prefixId}-role`}>
              <label className={labelClassName}>{this.props.fields.role}</label>
              <Select
                className="form--element--select"
                classNamePrefix="react-select"
                id={`${this.props.prefixId}-myRole`}
                name="type of restaurants"
                placeholder={this.props.fields.role}
                isSearchable={false}
                isClearable={false}
                cache={false}
                onChange={this.handleRoles}
                options={roles}
              />
            </div>

            <div className="my-6">
              <AcceptTerms
                color={this.props.color}
                fields={this?.props?.fields}
                acceptStateHandler={this.acceptStateHandler}
                submitted={this.state.submitted}
              />
            </div>

            <Button
              variant={this.props.color === 'white' ? 'inverse' : 'primary'}
              onClick={this.form1Click}
              className={`
                ${
                  // this.props.parentId === '#block-hero-form'
                  this.props.color === 'white' ? 'mt-50' : 'mt-30 mb-50'
                }
                ${
                  this.props.parentId === '#contact-right'
                    ? 'mt-30 md:mb-100 mb-0'
                    : ''
                }
            `}>
              {this.props.fields.submit}
            </Button>
          </div>

          <div className={`form-2`}>
            <p
              className={`h3 mb-6 ${
                // this.props.parentId === '#block-hero-form'
                this.props.color === 'white' ? 'color--white' : 'color--main'
              }`}>
              {this.props.fields.thank_you_heading}
            </p>
            <p
              className={`mb-12 md:mb-20 ${
                // this.props.parentId === '#block-hero-form'
                this.props.color === 'white' ? 'color--white' : ''
              }`}>
              {this.props.fields.thank_you_content.text}
            </p>
          </div>
        </div>
      </Section>
    );
  }
}
export default ContactForm;
